import React, { useState } from "react";

function AddIPModal({ show, onClose, onAdd }) {
  const [formData, setFormData] = useState({
    ip_address: "",
    description: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await onAdd(formData);
      setFormData({ ip_address: "", description: "" });
    } catch (error) {
      // Error handled in parent component
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    setFormData({ ip_address: "", description: "" });
    onClose();
  };

  const validateIP = (ip) => {
    const patterns = [
      /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/, // IPv4
      /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/(?:[0-9]|[1-2][0-9]|3[0-2])$/, // IPv4 CIDR
    ];
    return patterns.some(pattern => pattern.test(ip));
  };

  const isValidIP = validateIP(formData.ip_address);

  if (!show) return null;

  return (
    <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              <i className="fas fa-plus me-2"></i>
              Add IP to Whitelist
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
            ></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="mb-3">
                <label htmlFor="ip_address" className="form-label">
                  IP Address <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${
                    formData.ip_address && !isValidIP ? "is-invalid" : ""
                  }`}
                  id="ip_address"
                  name="ip_address"
                  value={formData.ip_address}
                  onChange={handleChange}
                  placeholder="e.g., 192.168.1.1 or 192.168.1.0/24"
                  required
                />
                {formData.ip_address && !isValidIP && (
                  <div className="invalid-feedback">
                    Please enter a valid IP address or CIDR notation
                  </div>
                )}
                <div className="form-text">
                  Enter an IPv4 address or CIDR notation (e.g., 192.168.1.0/24)
                </div>
              </div>

              <div className="mb-3">
                <label htmlFor="description" className="form-label">
                  Description
                </label>
                <textarea
                  className="form-control"
                  id="description"
                  name="description"
                  rows="3"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Optional description for this IP address"
                ></textarea>
              </div>

              <div className="alert alert-info">
                <i className="fas fa-info-circle me-2"></i>
                This IP will be automatically added to BitNinja whitelist.
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
                disabled={isSubmitting}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isSubmitting || !isValidIP || !formData.ip_address}
              >
                {isSubmitting ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Adding...
                  </>
                ) : (
                  <>
                    <i className="fas fa-plus me-2"></i>
                    Add to Whitelist
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AddIPModal;